<div appScrollTop [options]="scrollTopOptions" class="scrolltop">
	<span class="svg-icon" [inlineSVG]="'./assets/media/svg/icons/Navigation/Up-2.svg'"></span>
</div>